import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { preloadBrowserVoices } from './utils/builtinBrowserVoice';
import './index.css';
import './styles/design-system.css';
import './styles/container-system.css';

preloadBrowserVoices();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
